import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PATHS, LOGO } from "../lib/config";

export default function PathsSection() {
    const gp = PATHS["general-population"];
    const fm = PATHS["fitmama"];

    return (
        <section id="percorsi" className="relative bg-powder py-20 md:py-32">
            <div className="max-w-[1600px] mx-auto px-5 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="mb-10 md:mb-16 max-w-2xl"
                >
                    <p className="text-xs uppercase tracking-[0.28em] font-sans text-ink-muted mb-4">
                        <span className="inline-block w-8 h-px bg-fuchsia align-middle mr-3" />
                        Scegli il tuo percorso
                    </p>
                    <h2 className="font-serif text-4xl md:text-6xl leading-[0.95] font-bold text-ink">
                        Due strade, <span className="italic text-fuchsia">un'unica</span> cura per te.
                    </h2>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto">
                    {/* General Population */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8 }}
                    >
                        <Link
                            to={`/percorso/${gp.slug}`}
                            data-testid="path-general-population"
                            className="group relative block overflow-hidden aspect-[5/4] md:aspect-[4/3] bg-powder-darker border border-accent/20"
                        >
                            <div className="relative z-10 h-full p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 text-ink">
                                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden shadow-xl ring-4 ring-white shrink-0 self-start md:self-center">
                                    <img
                                        src={gp.image}
                                        alt={gp.label}
                                        className="w-full h-full object-cover object-[62%_35%] group-hover:scale-110 transition-transform duration-700"
                                    />
                                </div>

                                <div className="flex-1">
                                    <h3 className="font-serif text-3xl md:text-4xl leading-none mb-2">{gp.label}</h3>
                                    <p className="font-sans text-xs md:text-sm text-ink-muted max-w-sm mb-4">{gp.short}</p>
                                    <span className="inline-flex items-center gap-2 btn-accent self-start !py-2 !px-4 text-xs md:text-sm">
                                        Scopri il percorso <ArrowUpRight size={14} />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    </motion.div>

                    {/* FitMama */}
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-80px" }}
                        transition={{ duration: 0.8, delay: 0.1 }}
                    >
                        <Link
                            to={`/percorso/${fm.slug}`}
                            data-testid="path-fitmama"
                            className="group relative block overflow-hidden aspect-[5/4] md:aspect-[4/3] bg-powder-darker border border-fuchsia/20"
                        >
                            <div className="relative z-10 h-full p-5 md:p-7 flex flex-col md:flex-row md:items-center gap-4 md:gap-6 text-ink">
                                <motion.img
                                    src={LOGO}
                                    alt="FitMama"
                                    whileHover={{ scale: 1.04 }}
                                    transition={{ duration: 0.6 }}
                                    className="w-24 h-24 md:w-32 md:h-32 rounded-full object-cover shadow-xl ring-4 ring-white shrink-0 self-start md:self-center"
                                />

                                <div className="flex-1">
                                    <h3 className="font-serif text-3xl md:text-4xl leading-none mb-2">
                                        <span className="text-fuchsia">#</span>{fm.label}
                                    </h3>
                                    <p className="font-sans text-xs md:text-sm text-ink-muted max-w-sm mb-4">{fm.short}</p>
                                    <span className="inline-flex items-center gap-2 btn-fuchsia self-start !py-2 !px-4 text-xs md:text-sm">
                                        Scopri il percorso <ArrowUpRight size={14} />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
